import React, { useContext } from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

import config from '../../config/config'
import { formatDate } from '../../utils/dateUtils'
import { useAuth, AuthContext } from '../../contexts/AuthContext'
import { setFlashMessage, useWebsite } from '../../contexts/WebsiteContext'
import { LOGIN_PATH } from '../../config/routes'

const CommentThumbnail = ({ comment, onStatusChange }) => {
  const { t } = useTranslation()
  const { token } = useAuth()
  const { logout } = useContext(AuthContext)

  const navigate = useNavigate()

  const updateStatus = async (status) => {
    try {
      await axios.put(
        `${config.apiUrl}poi-comment/${comment.id}`,
        { status },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      onStatusChange(comment.id, status)
      setFlashMessage(t('SUCCESS_STATUS_UPDATED_MESSAGE'), 'success')
    } catch (error) {
      //console.error('Error updating poi comment status:', error);
      if (error.response && error.response.status === 401) {
        logout()
        navigate(LOGIN_PATH)
      } else if (error.response) {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
        console.error('Erreur lors du PUT Comment')
      }
    }
  }

  if (!comment.comment) {
    return
  }

  return (
    <div className="green-frame" style={{ margin: '5px 10px' }}>
      <h5>
        Auteur: {comment.createdBy.firstname} {comment.createdBy.lastname}
      </h5>
      <div style={{ fontStyle: 'italic' }}>
        Posté le {formatDate(comment.createdAt, true)}
      </div>
      <p>{comment.comment}</p>
      <div>
        {comment.status !== 'NEW' && (
          <Button
            variant="primary"
            onClick={() => updateStatus('NEW')}
            style={{ margin: '5px' }}
          >
            Marquer comme "Nouveau"
          </Button>
        )}
        {comment.status !== 'VALIDATED' && (
          <Button
            variant="primary"
            onClick={() => updateStatus('VALIDATED')}
            style={{ margin: '5px' }}
          >
            Marquer comme "Validé"
          </Button>
        )}
        {comment.status !== 'REJECTED' && (
          <Button
            variant="primary"
            onClick={() => updateStatus('REJECTED')}
            style={{ margin: '5px' }}
          >
            Marquer comme "Rejeté"
          </Button>
        )}
      </div>
    </div>
  )
}

export default CommentThumbnail
